module.exports = __webpack_public_path__ + "static/media/bobsalm.ec4aee79.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bobsalm.webp
// module id = 340
// module chunks = 0